import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';

export interface AccCurrencyRate {
  id: number;
  currencyId: number;
  rateDate: string;
  rate: number | string;
  currency?: { id: number; code: string; name: string; symbol?: string | null };
  createdAt: string;
  updatedAt: string;
}

export const useAccCurrencyRates = (searchParams?: string, page = 1, limit = 25, options?: ListQueryOptions) => {
  const q = options ? buildListQuery(searchParams, page, limit, options) : null;
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<AccCurrencyRate> | AccCurrencyRate[]>(
    q ? `${moduleConfig.module.api.list}${q}` : null,
    fetcher,
  );
  const normalized = normalizePaginatedListResponse<AccCurrencyRate>(data, page, limit);
  return { data: normalized.data, total: normalized.total, isLoading, isError: error, mutate };
};

export const useAccCurrencyRate = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AccCurrencyRate>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
